import React, { lazy } from 'react';

const ReportQuery = lazy(() => import('../pages/reports/reportQuery'));
const Reports = lazy(() => import('../pages/reports/reports'));
const Report = lazy(() => import('../pages/reports/report'));
const EditReport = lazy(() => import('../pages/reports/editReport'));
const QueryBuilder = lazy(() => import('../pages/tools/queryBuilder'));

const routes = [
  {
    path: 'reports',
    element: <Reports />,
  },
  {
    path: 'reports/graphQL',
    element: <ReportQuery />,
  },
  {
    path: 'reports/new',
    element: <EditReport />,
  },
  {
    path: 'reports/:reportId',
    element: <Report />,
  },
  {
    path: 'reports/:reportId/edit',
    element: <EditReport />,
  },
  {
    path: 'query',
    element: <QueryBuilder />,
  },
];

export default routes;
